import { FC } from "react"
import { UserbotPage } from "./userbotPage"
import { TemplatesTable } from "../components"

export const TemplatesGalleryPage: FC = () => (
  <UserbotPage title="Шаблоны">
    <TemplatesTable />
  </UserbotPage>
)
